export const GET_PYTHON_PANEL_URL = '/api/get-python-panel-url';
